import {connect} from 'react-redux';
import React, {Component} from 'react';
import ReactPaginate from 'react-paginate';

import * as SearchConst from '../../constants/Search';
import {findObjects, setPageSize, setPage, setOrder} from '../../actions/Search';

const defaultProps = {
    setPage: page => {
    },
    findObjects: requestParams => {
    },
    setPageSize: pageSize => {
    }
};

class ResultSearchInfo extends Component {
    handlePageSizeClick = event => {
        event.preventDefault();

        const pageSize = parseInt(event.target.text, 10);

        this.props.setPageSize(pageSize);
        this.findObjectsAfterChangeRequestParam(SearchConst.REQUEST_PARAMS_NAMES.PAGE_SIZE, pageSize);
    };

    handlePageClick = data => {
        const page = data.selected + 1;

        this.props.setPage(page);
        this.findObjectsAfterChangeRequestParam(SearchConst.REQUEST_PARAMS_NAMES.PAGE, page);
    };

    handleOrderClick(orderType) {
        window.jQuery('.sort_to ul').hide();
        this.props.setOrder(orderType);
        this.findObjectsAfterChangeRequestParam(SearchConst.REQUEST_PARAMS_NAMES.ORDER, orderType);
    }

    findObjectsAfterChangeRequestParam = (name, value) => {
        const {requestParams} = this.props;
        const newRequestParams = Object.assign({}, requestParams);

        newRequestParams[name] = value;

        this.props.findObjects(newRequestParams);
    };

    render() {
        const {
            i18n,
            paging,
            requestParams,
            searchPage: {
                requestParams: {
                    page
                }
            }
        } = this.props;
        const pageCount = Math.ceil(paging.totalCount / requestParams.pageSize);

        let orderText = i18n['search.sortBy'];
        let order = requestParams.order;
        if (order != null) {
            switch (order) {
                case 'PRICE':
                    orderText = i18n['search.sortByPrice'];
                    break;
                case 'CREATE_TIME':
                    orderText = i18n['search.sortByDate'];
                    break;
                default:
                    break;
            }
        }

        return (
            <div className="flex">
                <h3>
                    {i18n['search.foundObjectsBefore']}&nbsp;
                    {paging !== undefined && paging.totalCount}&nbsp;
                    {i18n['search.foundObjectsAfter']}
                </h3>

                <form className="filter_page">
                    <div className="sort_to">
                        <span>{orderText}</span>
                        <ul>
                            <li key="PRICE" onClick={() => {
                                this.handleOrderClick("PRICE")
                            }}>{i18n['search.sortByPrice']}</li>
                            <li key="CREATE_TIME" onClick={() => {
                                this.handleOrderClick("CREATE_TIME")
                            }}>{i18n['search.sortByDate']}</li>
                        </ul>
                    </div>

                    <div className="in_page">
                        <span>{i18n['search.onThePage']}:</span>
                        {SearchConst.PAGE_SIZES.map(pageSize =>
                            <a
                                href=""
                                key={pageSize}
                                onClick={::this.handlePageSizeClick}
                                className={requestParams.pageSize === pageSize ? "active_page" : ""}>
                                {pageSize}
                            </a>
                        )}
                    </div>

                    <div className="link_page">
                        <ReactPaginate
                            nextLabel={'.'}
                            previousLabel={'.'}
                            forcePage={page - 1}
                            pageCount={pageCount}
                            pageClassName={'page'}
                            pageRangeDisplayed={2}
                            marginPagesDisplayed={1}
                            nextClassName={'next_page'}
                            previousClassName={'prev_page'}
                            activeClassName={'active_link_page'}
                            onPageChange={::this.handlePageClick}
                        />
                    </div>
                </form>
            </div>
        )
    }
}

ResultSearchInfo.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    searchPage: state.searchPage,
    paging: state.searchPage.searchResult.paging,
    requestParams: state.searchPage.requestParams
});

const mapDispatchToProps = {
    setPage,
    setOrder,
    findObjects,
    setPageSize
};

export default connect(mapStateToProps, mapDispatchToProps)(ResultSearchInfo);



// WEBPACK FOOTER //
// ./src/components/Search/ResultSearchInfo.js